
// subscribes to any auction update (like auction closed early)
export const onUpdateAuctionSubscription = `
  subscription onUpdateAuction($auctionId: String!) {
    onUpdateAuction(AuctionId: $auctionId)  {
      AuctionId
      ResponseData
    }
  }`

// subscribes to any bid being made
export const onUpdateCurrentBidSubscription = `
  subscription onUpdateCurrentBid($auctionId: String!) {
    onUpdateCurrentBid(AuctionId: $auctionId)  {
      ItemId
      CurrentBid
      BidCount
      CurrentHighBidder
    }
  }`

// subscribes to any fixed item being purchased
export const onPurchaseFixedItemSubscription = `
  subscription onPurchaseFixedItem($auctionId: String!) {
    onPurchaseFixedItem(AuctionId: $auctionId)  {
      FixedItemId
      TotalItemsPurchased
    }
  }`

// subscribes to any bid being made
export const onMakeDonationSubscription = `
  subscription onMakeDonation($auctionId: String!) {
    onMakeDonation(AuctionId: $auctionId)  {
      AuctionId
      RegistrationId
      UserDonationTotal
      AuctionDonationTotal
    }
  }`



